import type { FC, ReactNode } from "react";

import {
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

interface DialogBodyProps {
  title?: string;
  children: ReactNode;
  classes?: string;
}

const DialogBody: FC<DialogBodyProps> = ({ title, children, classes }) => {
  return (
    <DialogContent
      className={cn("sm:max-w-[423px] rounded-[8px] p-4 sm:p-6", classes)}
    >
      {title && (
        <DialogHeader className="items-start">
          <DialogTitle className="font-extrabold text-lg">{title}</DialogTitle>
        </DialogHeader>
      )}
      {children}
    </DialogContent>
  );
};

export default DialogBody;
